// client/src/services/dashboardService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const getOverview = async () => {
  const response = await fetch(`${apiUrl}/dashboard/overview`, { headers: authHeaders() });
  if (response.status === 401) authService.handleUnauthorized();
  if (!response.ok) throw new Error('Erreur lors du chargement du résumé.');
  return await response.json();
};

const dashboardService = { getOverview };

export default dashboardService;
